<template>
    <div>
        <template v-if="!isMine">
            <div :class="[
                'message-initiator',
                {
                    'padding-r-4': showAvatar
                }
            ]">
                <div class="message-initiator_left" v-if="showAvatar">
                    <img :src="avatar || avatarList[avatarType]" :class="[
                        'message-avatar',
                        {
                            'circular-avatar': circular,
                            'avatar-32': size === 'small',
                            'avatar-36': size === 'middle'
                        }
                    ]">
                </div>
                <div class="message-initiator_right">
                    <div class="message-initiator_title" v-if="showNick">{{nick}}</div>
                    <div class="message-initiator_content">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="message-receive padding-l-4">
                <div class="message-receive_left">
                    <div class="message-receive_title" v-if="showNick">{{nick}}</div>
                    <div class="message-receive_content">
                        <slot></slot>
                    </div>
                </div>
                <div class="message-receive_right" v-if="showAvatar">
                    <img :src="avatar || avatarList[avatarType]" :class="[
                        'message-avatar',
                        {
                            'circular-avatar': circular,
                            'avatar-32': size === 'small',
                            'avatar-36': size === 'middle'
                        }
                    ]">
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "messageTitle",
    props: {
        nick: {
            type: String,
            default: '暂无昵称'
        },
        avatar: {
            type: String,
            default: ''
        },
        avatarType: {
            type: String,
            default: 'custom'
        },
        circular: {
            type: Boolean,
            default: true
        },
        showNick: {
            type: Boolean,
            default: true
        },
        showAvatar: {
            type: Boolean,
            default: true
        },
        isMine: {
            type: Boolean,
            default: true
        },
	    size: {
	        type: String,
	        default: 'small'
	    }
    },
    data() {
        return {
	        avatarList: {
                custom: require('../../../assets/instantMessaging/custom_avatar.svg'),
                staff: require('../../../assets/instantMessaging/staff_avatar.svg')
	        }
        }
    },
    computed: {
        classObject: function () {
            return [
                'message-avatar',
                `avatar${this.size}`,
                {
	                'circular-avatar': this.circular
                }
            ]
        }
    }
}
</script>

<style scoped lang="less">
.padding-l-4 {
    padding-left: 4px;
}

.padding-r-4 {
    padding-right: 4px;
}

.avatar-32 {
    width: 32px;
    height: 32px;
}

.avatar-36 {
    width: 36px;
    height: 36px;
}

.message-avatar {
    vertical-align: top;
}

.circular-avatar {
    border-radius: 50%;
}

.message-receive {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;

    .message-receive_left {
        .message-receive_title {
            font-family: PingFangSC-Regular;
            text-align: right;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 14px;
            letter-spacing: 0;
            margin-bottom: 8px;
        }

        .message-receive_content {
            display: flex;
            align-items: flex-end;
            position: relative;
            justify-content: flex-end;
        }
    }

    .message-receive_right {
        margin-left: 8px;
    }
}

.message-initiator {
    display: flex;
    margin-top: 20px;

    .message-initiator_left {
        margin-right: 8px;
    }

    .message-initiator_right {
        .message-initiator_title {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 14px;
            letter-spacing: 0;
            margin-bottom: 8px;
        }

        .message-initiator_content {
            display: flex;
            align-items: flex-end;
            position: relative;
        }
    }
}

</style>
